// frontend/src/features/equipment/EmptyEquipmentState.tsx
import { Paper, Stack, Text, Button, ThemeIcon } from '@mantine/core';
import { IconSettings } from '@tabler/icons-react';

interface EmptyEquipmentStateProps {
  onSetupClick: () => void;
  onAddManualClick: () => void;
}

/**
 * Empty state component shown when user has no equipment.
 * Provides entry points to the setup wizard or manual equipment form.
 */
export function EmptyEquipmentState({
  onSetupClick,
  onAddManualClick,
}: EmptyEquipmentStateProps) {
  return (
    <Paper
      p="xl"
      withBorder
      style={{ textAlign: 'center' }}
      data-testid="empty-equipment-state"
    >
      <Stack align="center" gap="md">
        <ThemeIcon size={64} radius="xl" variant="light" data-testid="empty-state-icon">
          <IconSettings size={32} />
        </ThemeIcon>

        <Text fw={500} size="lg">
          No equipment yet
        </Text>

        <Text c="dimmed" size="sm" maw={300}>
          Track your tank's equipment to monitor maintenance schedules and warranty
          info.
        </Text>

        <Button size="md" onClick={onSetupClick}>
          Set Up Equipment
        </Button>

        <Button
          variant="subtle"
          size="sm"
          onClick={onAddManualClick}
        >
          or add items manually
        </Button>
      </Stack>
    </Paper>
  );
}
